import React from 'react';
import createReactClass from 'create-react-class';
import Register from '../components/register';
import DocumentTitle from 'react-document-title';
import LP from 'modules/app/helpers/lp';

var RegisterContainer = createReactClass({

    render: function() {
        return (
            <DocumentTitle title={`${generalSettings._htmlTitle}: ${LP('login', 'loginRegisterTitle', 'titlecase')}`}>
                <Register />
            </DocumentTitle>

        );
    }

});

export default RegisterContainer;